"use client"

import { useTaskContext } from "@app/context/TaskContext"
import { usePersonalAssistantMessageContext } from "@app/context/PersonalAssistantMessageContext"
import LoadingScreen from "../common/LoadingScreen"
import Home from "../home/Home"

export default function HomeView() {
  const personalAssistantMessageContext = usePersonalAssistantMessageContext()
  const taskContext = useTaskContext()

  if (!taskContext || !personalAssistantMessageContext) {
    return <LoadingScreen />
  }

  return <Home />
}
